import { IViolation } from "./Violation.interface"
import PaperBox from "components/PaperBox"
import { Box, Chip, Divider, Grid, TextField, Typography } from "@mui/material"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faDiamondExclamation, faInfoCircle } from "@fortawesome/pro-solid-svg-icons"
import theme from "css/theme/light"
import ViolationDrivingTypesAdd from "pages/violation/components/ViolationDrivingTypesAdd"
import ViolationDrivingTypesRemove from "pages/violation/components/ViolationDrivingTypesRemove"
import { useEffect, useState } from "react"
import { StyledPrimaryAvatar } from "shared/styled/Global"
import { useTranslation } from "react-i18next"

function violationDriverTypesList(items: any) {
  return items?.map((item: any) => {
    return {
      ...item,
      listId: item.id
    }
  })
}

const Violation = ({ values, handleBlur, handleChange, touched, errors, setFieldValue }: IViolation) => {
  const [violationDrivingTypes, setviolationDrivingTypes] = useState(
    values ? violationDriverTypesList(values.violationDrivingTypes) : []
  )
  const { t } = useTranslation()

  useEffect(() => {
    setFieldValue("violationDrivingTypes", violationDriverTypesList(violationDrivingTypes))
  }, [violationDrivingTypes])

  return (
    <PaperBox>
      <Grid container direction="row" justifyContent="space-between" alignItems="center">
        <Grid item xs={2}>
          <Box>
            <StyledPrimaryAvatar
              aria-label="Violation">
              <FontAwesomeIcon icon={faDiamondExclamation} size="lg" />
            </StyledPrimaryAvatar>
          </Box>
        </Grid>

        <Grid item xs={6}>
          <Typography variant="h5">{t("violation.violation", "Violation")}</Typography>
        </Grid>
        <Grid item xs={4}>
          <Chip
            color={values.violationActive ? "success" : "error"}
            label={values.violationActive ? t("global.activated", "Activated") : t("global.not_active", "Not active")}
          />
        </Grid>
      </Grid>
      {values.violationActive ? (
        <Box marginTop={2}>
          <Divider />
          <Box marginY={2}>
            <Grid container direction="row" spacing={2} justifyContent="space-between" alignItems="center">
              <Grid item xs={12} mb={3}>
                <TextField
                  fullWidth
                  id="violationEmail"
                  label={t("settings.form.email_for_violations", "Email for violations")}
                  value={values.violationEmail}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.violationEmail && errors.violationEmail ? true : false}
                  helperText={touched.violationEmail && errors.violationEmail ? errors.violationEmail : null}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12} mb={3}>
                <ViolationDrivingTypesAdd
                  onSubmit={(item: any) => {
                    setviolationDrivingTypes((s: any) => {
                      return [
                        ...s,
                        {
                          ...item,
                          id: 0
                        }
                      ]
                    })
                  }}
                />
                <ViolationDrivingTypesRemove
                  categories={violationDrivingTypes}
                  removeViolationDrivingType={(item: any) => {
                    setviolationDrivingTypes((s: any) => {
                      return s.filter((x: any) => x.listId !== item.listId)
                    })
                  }}
                />
              </Grid>
            </Grid>
          </Box>
        </Box>
      ) : (
        <Box
          marginY={2}
          display="flex"
          justifyContent="flex-start"
          flexDirection="column"
          bgcolor={(theme.palette as any).primary[300]}
          borderRadius="8px"
          color={(theme.palette as any).primary[800]}
          p={2}
          gap={1}>
          <Box fontWeight="600">
            <FontAwesomeIcon icon={faInfoCircle} size="1x" /> {" "}
            {t("settings.form.active_deviation_support", "Contact company administrator to activate violations on the company")}
          </Box>
        </Box>
      )}
    </PaperBox>
  )
}

export default Violation
